import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useRouteError } from "react-router";

import { buttonVariants } from "../button";

export const GlobalError = ({ appName }: { appName: string }) => {
  const error = useRouteError();
  const { t } = useTranslation();

  // captureRemixErrorBoundaryError(error);

  const errorResponse = error instanceof Error ? error : undefined;

  return (
    <div className="flex h-[70vh] flex-col items-center justify-center gap-6">
      {process.env.NODE_ENV === "development" && (
        <code className="text-xs text-red-600">{errorResponse?.stack}</code>
      )}
      <div className="relative top-0 z-50 flex h-14 w-full items-center justify-center bg-black/30 bg-white backdrop-blur-sm">
        <Link
          to="/"
          prefetch="render"
          className="flex items-center space-x-1 hover:cursor-pointer"
        >
          <div className="font-geist text-2xl font-semibold tracking-tighter whitespace-nowrap sm:block">
            {appName}
          </div>
          <img
            alt={appName}
            src="/input.svg"
            className="h-8 w-8 antialiased dark:invert"
          />
        </Link>
      </div>
      <div className="mx-4 max-w-md rounded-lg border bg-white p-8 pb-6 text-center dark:bg-zinc-900">
        <h2
          id="error-title"
          className="mb-4 text-xl font-semibold tracking-tight text-zinc-800 dark:text-zinc-100"
        >
          {t("Oops! An unexpected error occurred.")}
        </h2>
        <p className="text-sm leading-6 text-zinc-600 dark:text-zinc-300">
          {t(
            "Our team has been notified and will look into it. Feel free to try again later.",
          )}
        </p>

        <p className="mt-4 text-sm leading-6 text-zinc-600 dark:text-zinc-300">
          <a
            className="cursor-pointer underline decoration-from-font underline-offset-2 hover:opacity-80"
            rel="ugc"
            href="mailto:alexandre@godard.me"
          >
            {t("Share your feedback")}
          </a>
        </p>
        <p className="mt-6 font-[menlo] text-[10px] opacity-40">
          (aP2ibV8Zotj)
        </p>
      </div>
      <Link
        className={buttonVariants({ variant: "default" })}
        to="/"
        prefetch="render"
      >
        {t("Go back home")}
      </Link>
    </div>
  );
};
